import { NotificationAlertOverride } from ".";
import { verificationService } from "../../../../../shared/services/verificaiton";
import { AnyNotificationContext } from "../../Notifications";

export const BankingFailed: NotificationAlertOverride<
  AnyNotificationContext
> = (_, history) => ({
  action: {
    text: "Complete verification",
    onClick: async () => {
      await verificationService.completeBankingVerification(history);
    }
  }
});
